import { Button, Col, Descriptions, Row, Table, Typography } from "antd";
import type { DescriptionsProps } from "antd";
import { useOrganization } from "../organization/OrganizationContext";
import OrgTitle from "../organization/orgTitleInfo";

const { Text, Title } = Typography;

const SubscriptionLayout: React.FC = () => {
  const { organization, loading, subscription, subscriptionFeatures } = useOrganization();

  if (loading) {
    return (
      <div
        style={{
          background: "white",
          borderRadius: 4,
          boxShadow: "0 0 8px 0 #cbcbcb",
          padding: 20,
          textAlign: "center"
        }}
      >
        <Title level={4}>Loading...</Title>
      </div>
    );
  }

  const getDaysFromToday = (dateString: string) => {
    const currentDate = new Date();
    const targetDate = new Date(dateString);
    const differenceMs = targetDate.getTime() - currentDate.getTime();
    const differenceDays = Math.ceil(differenceMs / (1000 * 60 * 60 * 24));
    return differenceDays;
  };

  const formatDate = (dateString: string) => {
    const date = new Date(dateString);
    let day: string | number = date.getUTCDate();
    let month: string | number = date.getUTCMonth() + 1; // Months are zero-based, so we add 1
    const year = date.getUTCFullYear();
    day = day < 10 ? "0" + day : day;
    month = month < 10 ? "0" + month : month;
    const formattedDate = day + "/" + month + "/" + year;
    return formattedDate;
  };

  const items: DescriptionsProps["items"] = [
    {
      key: "1",
      label: "Plan",
      children: subscription?.PlanName,
      span: 1,
    },
  ];

  const items2: DescriptionsProps["items"] = [
    {
      key: "3",
      label: "Status",
      children:
        getDaysFromToday(subscription?.ExpireAt || "") >= 0
          ? "Subscribed"
          : "Expired",
      span: 1,
    },
  ];

  const items3: DescriptionsProps["items"] = [
    {
      key: "2",
      label: "Automatic Renewal",
      children: subscription?.AutoRenew ? " Yes" : "No",
      span: 1,
    },
    // {
    //   key: "4",
    //   label: subscriptions.AutoRenew ? "Next Billing Date" : "Expiry Date",
    //   children: formatDate(subscriptions.ExpireAt),
    //   span: 1,
    // },
  ];

  /*
  const generateURLLink = async () => {
    if (organization?.ID) {
      const res = await getSubscriptionLink(organization.ID);
      if (res.status === 200) {
        const data = await res.json();
        const win = window.open(data.url, "_blank");
        if (win !== null) win.focus();
      }
    }
  };*/

  return (
    <>
      <OrgTitle title={organization?.Name} dayFromToday={getDaysFromToday(subscription?.ExpireAt || "")} />
      <div
        style={{
          background: "white",
          borderRadius: 4,
          boxShadow: "0 0 8px 0 #cbcbcb",
          padding: 20,
        }}
      >
      <div style={{ textAlign: "right", marginBottom: 20 }}>
        <Button
          type="primary"
          // onClick={generateURLLink}
          disabled
          title="Recurring subscription is not available at the moment."
        >
          Manage Subscription Plan
        </Button>
      </div>
      <Row gutter={[20, 20]}>
        <Col lg={8} md={24} sm={24} xs={24}>
          <Descriptions
            bordered
            items={items}
            labelStyle={{ backgroundColor: "#f0f0f0", width: 122 }}
          />
        </Col>
        <Col lg={8} md={24} sm={24} xs={24}>
          <Descriptions
            bordered
            items={items2}
            labelStyle={{ backgroundColor: "#f0f0f0", width: 122 }}
          />
        </Col>
        <Col lg={8} md={24} sm={24} xs={24}>
          <Descriptions
            bordered
            items={items3}
            labelStyle={{ backgroundColor: "#f0f0f0", width: 122 }}
          />
        </Col>
        <Col span={24} style={{ textAlign: "right" }}>
          <Text type={subscription?.AutoRenew ? undefined : "danger"}>
            ({subscription?.AutoRenew ? "Next Billing Date" : "Expiry Date"}:
            &nbsp;
            {formatDate(subscription?.ExpireAt || "")})
          </Text>
        </Col>
      </Row>
      </div>

      {
        (subscriptionFeatures && subscriptionFeatures.length > 0) ? <>
          <div
            style={{
              background: "white",
              borderRadius: 4,
              boxShadow: "0 0 8px 0 #cbcbcb",
              padding: 20,
              marginTop: 20
            }}
          >
              <Table
              pagination={false}
              rowKey="name"
              columns={[
                {
                  title: "Feature",
                  dataIndex: "name",
                  key: "name",
                  render: (text: string) => text.replace("_", " ")
                },
                {
                  title: "Expiry Date",
                  dataIndex: "expired_at",
                  key: "expired_at",
                  render: (text: string | null) => {
                    if (text === null) {
                      return "Active";
                    }

                    return formatDate(text);
                  }
                },
              ]}
              dataSource={subscriptionFeatures}
            />
          </div>
        </> : <></>
      }
    </>
  );
};

export default SubscriptionLayout;
